import React, { createContext, useRef, useState } from "react";

const defaultState = {};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {
  const [uuid, setUuid] = useState(null);
  const headerRef = useRef(null);
  const stickyIsiRef = useRef(null);
  const isiRef = useRef(null);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [is404Page, setIs404Page] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [exitUrl, setExitUrl] = useState("");

  const openExitModal = (url) => {
    setExitUrl(url);
    setShowExitModal(true);
  };

  const closeExitModal = () => {
    setShowExitModal(false);

    // bug fix: prevent the modal from closing before the exit URL is opened
    // without this, the exit url clears too fast, and the browser opens a tab with the same url instead of the exit one
    setTimeout(() => {
      setExitUrl("");
    }, 100);
  };

  const store = {
    uuid,
    setUuid,
    headerRef,
    stickyIsiRef,
    isiRef,
    isHeaderVisible,
    setIsHeaderVisible,
    is404Page,
    setIs404Page,
    showExitModal,
    exitUrl,
    openExitModal,
    closeExitModal,
  };

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export default AppContext;

export { AppProvider };
